module.exports = __webpack_public_path__ + "img/thue.f159e66d.png";